// NOTES
//-------------------------------------------------------------------------------------------------------------------------
// Component: cas-banner
// Created: 7/2017
// Author: Adam Smith
// This is a "message" banner designd to be placed at thetop of a screen to notify users of some event.


// Example HTML usage:
/*
    <cas-banner #practicesGrid
                [settings]="_bannerSettings" 
                (onSomeEvent)="bannerSomeEventClicked($event)">
    </cas-banner>
*/

// Example JS usage:
/*
    //Reference to the grid if you want to call its public functions directly in javascript
    @ViewChild('practicesBanner') practicesBanner; 
*/

// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// CASBannerComponent
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Component({
  selector : 'cas-banner',
  styles : ['.__cas_banner_x_div{font-weight:bold;cursor:pointer;padding:4px;border-radius:4px}.__cas_banner_x_div:hover{background-color:#c8ecfa}.__cas-banner{display:flex;align-items:center;color:#000;border-style:solid;border-width:4px;border-bottom:0;border-top:0;border-right:0;border-radius:2px;margin:10px 20px 10px 20px;padding:2px 10px}.__cas-banner-category-error{border-color:#b70f0a;background-color:#f1cfce}.__cas-banner-category-info{border-color:#296cbd;background-color:#d4e2f2}.__cas-banner-category-success{border-color:#308a42;background-color:#d6e8d9}.__cas-banner-category-warning{border-color:#fdb81e;background-color:#fff1d2}'],
  template : '<!--Banner-->\n<div *ngIf="_banners.length > 0" id="bannerContainer" class="__cas_banner_main_div" title="Press CTLR + ALT + X to close all banners">\n\n    <div *ngFor="let banner of _banners" class="__cas-banner {{banner.category.css}}">\n\n        <img src="{{banner.category.imgSrc}}" style="width:16px; margin-right:10px;" />\n\n        <!--Visual Message Presentation-->\n        <div style="flex-grow:1;" [innerHTML]="GetTextForBanner(banner.id)"></div>\n\n        <!--Visual Close Button Presentation-->\n        <div tabindex="0"\n             class="__cas_banner_x_div cpd-focusable"\n             role="button"\n             (click)="_closeClicked(banner);"\n             (keydown)="_keydown_closeClicked($event, banner);"\n             aria-label="Close Banner (Press CTLR + ALT + X to close all banners)">X</div>\n\n    </div>\n\n</div>\n\n<!--_domSanitizer.bypassSecurityTrustHtml(html);-->'
})
export class CASBannerComponent implements OnInit {


    // INPUTS/OUTPUTS
    //-------------------------------------------------------------------------------------------------------------------------
    //@Input() settings;

    //@Output() onExportClicked = new EventEmitter();
    

    // GETTERS/SETTERS
    //-------------------------------------------------------------------------------------------------------------------------

    
    // PRIVATE MEMBERS
    //-------------------------------------------------------------------------------------------------------------------------
    _banners = [];
    _bannersHash = {};

    _categories = {
        error: { name: 'error', css: '__cas-banner-category-error', imgSrc:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAwCAMAAABZu7juAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA2UExURQAAAEBAQEhISEVFRUhISEZGRkhISEdHR0hISEdHR0hISEdHR0hISEdHR0hISEdHR0hISP///1pj5lMAAAAQdFJOUwAQIDBAUGBwgI+fr7/P3+8jGoKKAAAACXBIWXMAABcRAAAXEQHKJvM/AAABQElEQVRIS62V25aDIAxF0YI3bs7//+yAHhXwRDtrzX6isJumEIhq6fRkfYgxBDtpzInoOa4l9ukb2sMq8AMWWz4WRoPvIVQMdRolI5SCGUuUGdJBt2BBwMEDL3bjj5h8oMjHyP/ywkBWXcDMyU8G44N47OeEiQumr8tu9/dUqL7u4cmucH0LT4IL+haebaKg52JwGJcIeky7iGGFoKdsDEYVkj7ySpR0q+idkPVbAWQkPf5Vp8Uo6eu/6CKKPC0ygdaAiHt+MFoWXgQSAy8xiVTw9Jw4PtX7/WKLTEln2QjH9En691fbZlv1+FTAdXSSe3iq78FT9l/VzfnoKY2ZR84n9aV17FQNROhiF0sHc+fFd7X9kk8TOyM3nEgaZWrDwsVy29kTBlKdfrwncmLqE47OPMgbZnL5R2Jws25cpX4BXcBsnbPH+R4AAAAASUVORK5CYII=" },
        info: { name: 'info', css: '__cas-banner-category-info', imgSrc: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAwCAMAAAC2edPQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA2UExURQAAAEBAQEhISEVFRUhISEZGRkhISEdHR0hISEdHR0hISEdHR0hISEdHR0hISEdHR0hISP///1pj5lMAAAAQdFJOUwAQIDBAUGBwgI+fr7/P3+8jGoKKAAAACXBIWXMAABcRAAAXEQHKJvM/AAABQUlEQVRIS7WWUaNEIBBGS3aTMO7//7O3dj8k38TLnqeRg5qmYi44H6ZFRJY4eoc2lW6Y1xIJHe4w+iDwCqL2hGV2JkA40y+4fUV6OAVeefkXD2vH44bGAA/c6dUg7vV1fcNNuGbfN/bJs+c50hDoZkDDwV8G8QGG0F17w/31O9PX12v+mHVLBqv4nw+wXGp+nuYJ8RNSiizCZ3TmhegZnmWnQTAR0TOi0VcJQ7iv5TP5tDRVf/25T2tf9RdeDqo/mYDohOqPvB5U/83rTfXTAmATpvlzqv834hLNz7sc65Diy2fBj7gqUPyYdfYB7m/b+nUKuL9tufbZGlgsfOPQ0kResBMspzWnA4DkqKI69GjZFYS986C9r1THV6ZxyJRDPbDaICbthHfsian10+GqfwIJt78ovR+n9JDIHAdXZcWYf8nXbv3DA9kcAAAAAElFTkSuQmCC" },
        success: { name: 'success', css: '__cas-banner-category-success', imgSrc: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC8AAAAwCAMAAAC2edPQAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABjUExURQAAAEBAQEhISEVFRUhISEZGRkhISEdHR0hISEdHR0hISEdHR0hISEdHR0hISEdHR0hISFNTU19fX2pqanZ2doGBgY2NjZiYmKOjo6+vr7q6usbGxtHR0d3d3ejo6PT09P///0My8mIAAAAQdFJOUwAQIDBAUGBwgI+fr7/P3+8jGoKKAAAACXBIWXMAABcRAAAXEQHKJvM/AAABqklEQVRIS42W2WKDIBBFMZgoagRN2mZr4/9/ZVkuiCyS8zTAHWSYASQRtGHDyDkf+66h6MtyaM/Ch7MDRlLUjEPn0ec8qpRawSDYUo8YjuE1NB5NZnJDA5WjwUCOFjpQkgdBlOVCnKCV0N21W1zyqm2OcnDISYuOEgjh8NFqFCbTn04vRKfkVWn66fkNS3+gtJfTc1msg0rzADvD/LdIrqYht6gyVo6Llt/Qkgs6wkpzeUv1261fLmh3d65a/oWWhJEeVoqfUC56sp6S+QHDYuQI1cBXvYzsBdNwk+rld0bLwInN1qwm8xymR0IuhNMLPe4cjPw1oelY9RsHldSUXBCv9lcHI7/H8nFTDtbB1MAdvT4DYbA0xiGoAZ8uqAftoPBqwOcU1hscMnJ1AIJrUDtsasDjLOv/BNsiHXJyfctFB+ARJdXC9YHv0HLE2w56JS+dsBV7rW9SsIO9cqv8S+EzVtATip5d+BFqSbinKTYPQLRHEcGjV4qZucWD/Vs3eL4UO4+MH+pKlQtiyL3wNOUx7P100OCfgLPiL0rddIN04vzctzTYFUL+AUDrd13fBuCgAAAAAElFTkSuQmCC" },
        warning: { name: 'warning', css: '__cas-banner-category-warning', imgSrc:"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADkAAAAwCAMAAACcySJ/AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAA2UExURQAAAEBAQEhISEVFRUhISEZGRkhISEdHR0hISEdHR0hISEdHR0hISEdHR0hISEdHR0hISP///1pj5lMAAAAQdFJOUwAQIDBAUGBwgI+fr7/P3+8jGoKKAAAACXBIWXMAABcRAAAXEQHKJvM/AAABP0lEQVRIS52V25aCMAxFBxwGLyjx/392QnOEXpKSuF9sa85arm3T/PS44zPMRH9YBRletA5Yx7gS0Ve/d1w5SRfsIixbkJ7YBZhSkGjC3s3wRHLFgZtNj3DDiRPRI4w48/FAamPBmYuPHiEgadcjBCQdeoQrzk/J9QheSXfUHzgllXoEl6RKj+CSNKOY3htYeyQdeorkei7phtIqSQ98b/KLQqZMnkqSfk5UyRcqDHY9TJWkGTUqQ3576mRX0qGHqZM9SZkepkl2HsJMD9MmTUm5HqZNWtOi0MMoSUNS3c8a6rS4NP2soUkq9VgokrR+1mgk8bD00YxUjx6hktQ+d+q/kiglaXqsZDFSVT1WMu9x9bmzk9lD6Ncj7CNV09Pnc33zYekD08J7e3KSJF3PCUlSVI/A0yKuRxiVYemCln/wdFWz4zAhJQAAAABJRU5ErkJggg==" }
    };

    _lastBannerID = 0;

    //An event listener handler method that will have "this" prebound so removeListener will work (which can't handle
    //removing a listener if it was bound in the registration)
    _boundKeypressHandler = null;


    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(domSanitizer:DomSanitizer){
        this._domSanitizer = domSanitizer;

        //Prebind the listener
        this._boundKeypressHandler = this._handleGlobalKeypress.bind(this);

        //Register the handler globally to keyup
        window.addEventListener("keyup", this._boundKeypressHandler);
    };

    //==================================
    // ngOnDestroy
    //==================================
    ngOnDestroy(){
        window.removeEventListener("keyup", this._boundKeypressHandler);
    };

    //==================================
    // ngOnInit
    //==================================
    ngOnInit(){};


    // EVENT HANDLERS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // _closeClicked
    //==================================
    _closeClicked(banner){
        this.RemoveBanner(banner.id);
    };

    //==================================
    // _keydown_closeClicked
    //==================================
    _keydown_closeClicked($event, banner){
        if (event.keyCode == 13){
            this._closeClicked(banner);
        }
    };

    //==================================
    // _handleGlobalKeypress
    //==================================
    _handleGlobalKeypress(e){

        if (e.altKey && e.ctrlKey && e.key.toLowerCase() == "x"){

            e.preventDefault();
            e.stopPropagation();

            this.RemoveAllBanners();
            //console.log("REMOVING BANNERS", this);
        }
    };

    // PUBLIC FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // AddBanner
    //==================================
    //  category<string>:       //(req) one of: error, info, success, warning
    //  text<string>:           //(req) No longer allows HTML to make 508 support easier*
    //
    //  If you decide you must have HTML, you'll want to add another paramter for 508 without the markup.  Also, the Angular
    //  sanitizer stuff is ornery.
    AddBanner(category, text) {

        //Validate
        if (!this._categories[category]) { throw ("[cas-banner:AddBanner()] Unrecognized category: " + category); }
        if (!text || text.length == 0) { throw ("[cas-banner:AddBanner()] text argument is required"); }

        //Sometimes, unexpected javascript errors were getting sent to the banners.  This will make sure
        //they also get channelled into the console to make sure they are easy to spot, and more likely
        //to be readable in the case of embedded objects
        if (category == "error") { console.log(text); }

        //Check to see if an identical banner is already displayed
        var banner = this._banners.find(b => b.text == text && b.category.name == category);

        if (!banner) {

            //Create a new banner
            banner = {
                id: ++this._lastBannerID,
                text: text,
                category: this._categories[category],
                elAlert: null
            }

            //Save the banner in the collections
            this._banners.push(banner);
            this._bannersHash[banner.id] = banner;
        }

        //508 Alert

        //Remove any previous alerts
        if (banner.elAlert) {
            banner.elAlert.parentNode.removeChild(banner.elAlert); //IE Compatible
        }

        //Add the 508 alert outside of the angular content area (so it doesn't get constantly re-rendered or generally mucked with) and with static values
        banner.elAlert = document.createElement("span");
        banner.elAlert.style.cssText = "position:absolute;left:-5000px";
        banner.elAlert.setAttribute("aria-live", "assertive");
        banner.elAlert.setAttribute("role", "alert");
        banner.elAlert.innerHTML = text;
        document.body.appendChild(banner.elAlert);

        return banner.id;
    };

    //==================================
    // GetTextForBanner
    //==================================
    GetTextForBanner(bannerId) {

        var banner = this._bannersHash[bannerId];
        if (banner) {
            //return this._domSanitizer.bypassSecurityTrustHtml(banner.html);
            return banner.text;
        }
        else {
            throw ("[cas-banner.js] Unrecognized banner id:" + bannerId);
        }
    }

    //==================================
    // RemoveAllBanners
    //==================================
    RemoveAllBanners(){
        this._banners = [];
        this._bannersHash = {};
    };

    //==================================
    // RemoveBanner
    //==================================
    RemoveBanner(bannerId){
        let idx = this._banners.findIndex((b) => { return b.id == bannerId; });
        if (idx !=null && idx > -1){
            this._banners.splice(idx, 1);
        }
        delete this._bannersHash[0];
    };


    // PRIVATE FUNCTIONS
    //-------------------------------------------------------------------------------------------------------------------------


}
